import Block from "./Block.component";

export default Block;
